app.controller('programEdit', function ($scope) {
    $scope.programEdit = {
        exerciseBarCollapsed: true,
        exerciseData: {}
    };

    // Prompt before leaving program edit page
    var formSubmitBtn = document.getElementById('program_submit');
    var formCancelBtn = document.getElementById('program_edit_cancel');
    var isFormButtonClicked = false;
    if (formSubmitBtn) {
        window.addEventListener('beforeunload', function(event) {
            if (!isFormButtonClicked) {
                event.preventDefault();
                event.returnValue = '';
            }
        });
        formSubmitBtn.addEventListener('click', function() {
           isFormButtonClicked = true;
           window.setTimeout(function () {
               isFormButtonClicked = false;
           }, 500);
        });
    }
    if (formCancelBtn) {
        formCancelBtn.addEventListener('click', function() {
            isFormButtonClicked = true;
            window.setTimeout(function () {
                isFormButtonClicked = false;
            }, 500);
        });
    }
});
